/**
 * Movies Page.
 */
import MainTemplate from '@components/templates/main/ui/main';
import useSection from '@shared/components/utils/hooks/useSection';
import { QuerySections } from '@shared/types/enums/sections';

/**
 * Movies page component that displays movies content with highlights and reels.
 * Starts navigation in menu
 */
export default function MoviesPage() {
  const { complete, highlights, reels, onPagination } = useSection({
    section: QuerySections.MOVIES,
  });
  return (
    <MainTemplate
      flags={{ complete }}
      rails={reels}
      sliders={highlights}
      onPagination={onPagination}
    />
  );
}
